import React from 'react';
import { StarIcon, CheckCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { CART_URL } from '../utils/constants';
import { trackAddToCart } from '../utils/metaPixel';
const HERO_IMAGE = 'https://cdn.magicpatterns.com/uploads/5mvrAZi4ksYQuYpqMxtNCZ/hf_20260301_200634_f6423096-4839-4663-a182-24acafbc7063.jpg';
export function HeroSection() {
  return <section className="pt-20 pb-12 md:pt-28 md:pb-20 px-4 bg-cream overflow-hidden" data-id="element-120">
      <div className="max-w-3xl mx-auto flex flex-col items-center text-center space-y-6" data-id="element-121">
        <div className="inline-flex items-center space-x-1 text-caramel-dark font-bold text-sm md:text-base mb-2" data-id="element-122">
          <div className="flex" data-id="element-123">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-caramel text-caramel" data-id="element-124" />)}
          </div>
          <span className="ml-2 text-brown-dark opacity-80" data-id="element-125">
            Más de 2,037 alumnas
          </span>
        </div>

        <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-brown-dark leading-tight" data-id="element-126">
          Aprende a preparar flanes{' '}
          <span className="text-caramel-dark underline decoration-caramel decoration-4 underline-offset-4" data-id="element-127">
            SIN HORNO
          </span>{' '}
          (y sin baño María) en -15 minutos…
        </h1>

        <p className="text-lg md:text-xl text-gray-700 font-medium leading-relaxed" data-id="element-128">
          …y genera{' '}
          <span className="font-bold text-success-green" data-id="element-129">
            +400 USD a la semana extras
          </span>
          , desde tu casa, con recetas probadas y listas para vender.
        </p>

        {/* Hero Image — below stats, above CTA */}
        <div className="w-full max-w-xl mx-auto pt-2 pb-2" data-id="element-130">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-131">
            <img src={HERO_IMAGE} alt="Flan casero con caramelo — Flanes Sin Horno" className="w-full h-auto object-cover" data-id="element-132" />
            {/* Trust Badge overlay */}
            <div className="absolute bottom-3 right-3 bg-white/90 backdrop-blur-sm px-3 py-1.5 rounded-full shadow-lg border border-gray-100 flex items-center gap-1.5" data-id="element-133">
              <div className="w-2 h-2 bg-success-green rounded-full" data-id="element-134"></div>
              <span className="text-xs font-bold text-brown-dark" data-id="element-135">
                Compra Verificada
              </span>
            </div>
          </div>
        </div>

        <div className="pt-2 flex flex-col items-center w-full" data-id="element-136">
          <a href={CART_URL} onClick={trackAddToCart} className="w-full md:w-auto block text-center bg-cta-green hover:bg-green-700 text-white font-heading font-bold text-xl md:text-2xl py-4 px-8 rounded-xl shadow-lg animate-pulse-glow transition-all transform hover:scale-105" data-id="element-137">
            QUIERO MI RECETARIO »
          </a>
          <div className="flex flex-wrap justify-center items-center gap-x-4 gap-y-2 mt-4 text-xs md:text-sm text-gray-600 font-medium" data-id="element-138">
            <span className="flex items-center" data-id="element-139">
              <CheckCircleIcon className="w-3.5 h-3.5 mr-1 text-success-green" data-id="element-140" />{' '}
              Acceso inmediato por email
            </span>
            <span className="flex items-center" data-id="element-141">
              <CheckCircleIcon className="w-3.5 h-3.5 mr-1 text-success-green" data-id="element-142" />{' '}
              Pago único
            </span>
            <span className="flex items-center" data-id="element-143">
              <ShieldCheckIcon className="w-3.5 h-3.5 mr-1 text-caramel-dark" data-id="element-144" />{' '}
              Garantía 7 días
            </span>
          </div>
        </div>
      </div>
    </section>;
}